import { Order } from '@authority-labs/api-interfaces';
import {
  isInspectionReadonly as isReadonlyForStatus,
  isTesterRole
} from '@authority-labs/helpers';

/**
 * Determines if an inspection should be in readonly mode based on permissions,
 * order status and, while the order waits for review, who is asking.
 * @param hasManagePermission Whether the current user has manage/admin permission for inspections
 * @param order The order associated with the inspection
 * @param user The signed-in user (in review: the reviewer edits, testers do not)
 * @returns true if the inspection should be readonly, false otherwise
 */
export function isInspectionReadonly(
  hasManagePermission: boolean,
  order: Order | undefined,
  user?: { username?: string; role?: string }
): boolean {
  return isReadonlyForStatus(hasManagePermission, order?.status?.key, {
    username: user?.username,
    reviewedBy: order?.reviewedBy,
    isTester: isTesterRole(user?.role)
  });
}
